<div class="add-70">
    <div class="full-banner">
        <div class="container align-items-center flex-wrap h-100" style="display: grid;">
            <h2 class="font-600 text-center">
                The architects who brought simplicity to our vision
            </h2>
        </div>
    
        <div class="down-arrow">
            <img src="assets/img/drop_down.svg" alt="">
        </div>
    </div>
</div>


<div class="page-section">
    <app-client-marquee></app-client-marquee>
</div>

<div class="page-section">
    <div class="container">
        <h3 class="font-600 text-center mb-5">Our Board Members</h3>
        <ng-container *ngFor="let member of board_members; let i = index">
            <ng-container *ngIf="i % 2 == 0; else oddMemberCard">
                <div class="row align-items-center flex-wrap h-100 mb-4">
                    <div class="col-lg-4">
                        <div class="board-image">
                            <img [src]="member.img" [alt]="member.name" srcset="">
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div class="board-highlight">
                            <h4 class="board-name">
                                <span class="highlight-container">
                                    <span class="highlight">
                                        {{member.name}}
                                    </span>
                                </span>
                            </h4>
                        </div>
                        <h5 class="board-designation">{{member.designation}}</h5>
                        <p class="text-justify">{{member.description}}</p>
                    </div>
                </div>
            </ng-container>
            
            <ng-template #oddMemberCard>
                <div class="row align-items-center flex-wrap h-100 board-col mb-4">
                    <div class="col-lg-8 text-right">
                        <h4 class="board-name">
                            <span class="highlight-container">
                                <span class="highlight">
                                    {{member.name}}
                                </span>
                            </span>
                        </h4>
                        <h5 class="board-designation">{{member.designation}}</h5>
                        <p class="text-justify">{{member.description}}</p>
                    </div>
                    <div class="col-lg-4">
                        <div class="board-image">
                            <img [src]="member.img" [alt]="member.name" srcset="">
                        </div>
                    </div>
                </div>

            </ng-template>
        </ng-container>
    </div>

    <div class="container">
        <h3 class="font-600 text-center mb-5">Investors and Advisors</h3>
        <div class="row">
            <ng-container *ngFor="let investor of investors">
                <div class="col-lg-4 col-12 text-center">
                    <img [src]="investor.img" [alt]="" class="investor-image">
                    <div class="card investor-card">
                        <div class="card-body">
                            <h4 class="investor-name font-600">{{investor.name}}</h4>
                            <span class="investor-qualification">{{investor.qualification1}}</span>
                            <br>
                            <span class="investor-qualification">{{investor.qualification2}}</span>
                            <div class="set-description">
                                <p>{{investor.description}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>